import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  ALL_NODE_EVENT, CREATE_SCREENSHOT, LOAD_CONFIGURED_VIOLATIONS, LOAD_DAY_STAT, LOAD_EXPORT_STATUS, LOAD_LAST_SESSION, LOAD_NODE_STATE,
} from './actions';
import { DASHBOARD_MODULE, SYSTEM_MODULE } from '../../configs/moduleNames';
import { createLoadParameterReducer, createOperationStateReducer } from '../../utils/getCrudConfig';

const initialState = {
  loadingDayStat: false,
  dayStat: [],
  loadingLastSession: false,
  lastSession: [],
  loadingConfiguredViolations: false,
  configuredViolations: [],
  loadingExportStatus: false,
  exportStatus: [],
  loadingCreateScreenshot: false,
  loadingAllNodeEvent: false,
  loadingNodeState: false,
  nodeState: {},
};

const reducer = handleActions({
  ...createLoadParameterReducer(DASHBOARD_MODULE + LOAD_DAY_STAT, 'dayStat', 'loadingDayStat', []),
  ...createLoadParameterReducer(DASHBOARD_MODULE + LOAD_LAST_SESSION, 'lastSession', 'loadingLastSession', []),
  ...createLoadParameterReducer(DASHBOARD_MODULE + LOAD_CONFIGURED_VIOLATIONS, 'configuredViolations', 'loadingConfiguredViolations', []),
  ...createLoadParameterReducer(DASHBOARD_MODULE + LOAD_EXPORT_STATUS, 'exportStatus', 'loadingExportStatus', []),
  ...createOperationStateReducer(DASHBOARD_MODULE + CREATE_SCREENSHOT, 'loadingCreateScreenshot'),
  ...createOperationStateReducer(DASHBOARD_MODULE + ALL_NODE_EVENT, 'loadingAllNodeEvent'),
  ...createLoadParameterReducer(DASHBOARD_MODULE + LOAD_NODE_STATE, 'nodeState', 'loadingNodeState', {}),
}, initialState);

export default reducer;

export const getDashboardData = createSelector(
  [state => state[DASHBOARD_MODULE]],
  state => {
    const {
      loadingDayStat,
      dayStat,
      loadingLastSession,
      lastSession,
      loadingConfiguredViolations,
      configuredViolations,
      loadingExportStatus,
      exportStatus,
      loadingCreateScreenshot,
      loadingAllNodeEvent,
      loadingNodeState,
      nodeState,
    } = state;
    return {
      loadingDayStat,
      dayStat,
      loadingLastSession,
      lastSession,
      loadingConfiguredViolations,
      configuredViolations,
      loadingExportStatus,
      exportStatus,
      loadingCreateScreenshot,
      loadingAllNodeEvent,
      loadingNodeState,
      nodeState,
    };
  },
);
